export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/OnlineOnly.6d838e93.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};